/* unplugin-vue-components disabled */import i18n from '@/lang';
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.replace.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/web.url.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations, mapState, mapActions } from 'vuex';
import { apisystemsettingByCode, postChildrenAccountAnonymousLogin, apiinvite } from '@/api';
import TpDialog from '@/components/NewVuxComponents/TpDialog';
export default {
  name: 'app',
  components: {
    TpDialog: TpDialog
  },
  data: function data() {
    return {
      anoymousLogin: 0,
      showInviteModal: false,
      inviteTip: {} // 邀请提示
    };
  },
  computed: _objectSpread({}, mapState('globalStore', ['user', 'appointInfo', 'Authorization', 'RUN_ENV'])),
  watch: {
    $route: function $route(v) {
      if (['Home', 'Product'].includes(v.name)) {
        this.watchInvite();
      }
    }
  },
  created: function created() {
    var state = {
      title: 'title',
      url: '#'
    };
    window.history.pushState(state, state.title, state.url);
    window.RUN_ENV = 'PC';
    var u = navigator.userAgent;
    var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // g
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
    if (isAndroid) window.RUN_ENV = 'Android';
    if (isIOS) window.RUN_ENV = 'ios';
    this._RUN_ENV(window.RUN_ENV);
    document.body.classList.add("".concat(window.RUN_ENV, "-device"));
    var token = new URLSearchParams(location.search).get('token');
    this._openid(new URLSearchParams(location.search).get('openid'));
    this.autoLogin({
      token: token
    });
  },
  mounted: function mounted() {
    // 适配Android手机
    if (window.RUN_ENV === 'Android') {
      var htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
      var htmlDom = document.getElementsByTagName('html')[0];
      htmlDom.style.fontSize = htmlWidth / 30 + 'px';
    }
    this.autoJump();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('globalStore', ['_ApiSession'])), mapMutations('globalStore', ['_appointInfo', '_Authorization', '_user', '_RUN_ENV', '_openid'])), {}, {
    watchInvite: function watchInvite() {
      var _this$user,
        _this$user2,
        _this = this;
      // 检查是否被邀请
      if (this !== null && this !== void 0 && (_this$user = this.user) !== null && _this$user !== void 0 && _this$user.id && (this === null || this === void 0 ? void 0 : (_this$user2 = this.user) === null || _this$user2 === void 0 ? void 0 : _this$user2.id) !== -1) {
        // 是否被邀请 检测
        apiinvite().then(function (res) {
          if (res.success && res.data) {
            _this.inviteTip = res.data;
            _this.showInviteModal = true;
          }
        });
      }
    },
    // 邀请提示操作
    inviteRespond: function inviteRespond(type) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return apiinvite({
                  invite_result: type,
                  id: _this2.inviteTip.id
                }, 'put');
              case 2:
                res = _context.sent;
                if (res.success) {
                  _this2.$vux.toast.text(type === 2 ? i18n.tc("9") : i18n.tc("10"));
                  _this2.showInviteModal = false;
                } else {
                  _this2.$vux.toast.text(res.message || '');
                }
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    autoLogin: function autoLogin(_ref) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _this3$user;
        var token;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                token = _ref.token;
                if (!(!(_this3 !== null && _this3 !== void 0 && (_this3$user = _this3.user) !== null && _this3$user !== void 0 && _this3$user.id) && token)) {
                  _context2.next = 10;
                  break;
                }
                _this3._Authorization(token);

                // const url = location.href.r
                // location.href = url
                _context2.next = 5;
                return _this3._ApiSession();
              case 5:
                if (!_this3.appointInfo) {
                  _context2.next = 9;
                  break;
                }
                _this3.$router.replace({
                  name: 'ServiceDetail',
                  query: {
                    id: _this3.appointInfo.id,
                    productId: _this3.appointInfo.productId
                  }
                });
                _this3._appointInfo(null);
                return _context2.abrupt("return");
              case 9:
                if (_this3.user.type === 1 &&
                // 评价入口
                _this3.user.oid && _this3.user.evaluateState === 0 // 评价状态 未评价
                ) {
                  // 走评价工单
                  _this3.$router.replace({
                    name: 'ProjectDetailComment',
                    params: {
                      oid: _this3.user.oid
                    }
                  });
                } else {
                  // 普通登录
                  // this.$router.replace({ name: 'Home' })
                }
              // 去除token信息
              // location.search = ''
              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    autoJump: function autoJump() {
      console.log('AutoConsole: autoJump -> window.dxeTocObj', window.dxeTocObj);
      if (window.dxeTocObj) {
        if (window.dxeTocObj.page === 'goodsDetail') {
          this.$router.replace({
            name: 'productDetails',
            params: {
              id: window.dxeTocObj.id
            }
          });
        }
        if (window.dxeTocObj.token) {
          this._Authorization(window.dxeTocObj.token);
        }
        if (window.dxeTocObj.openid) {
          this._openid(new URLSearchParams(location.search).get('openid'));
        }
        if (window.dxeTocObj.token) {
          this.autoLogin({
            token: window.dxeTocObj.token
          });
        }
      }
    }
  })
};